<div class="bn-app-shield-setup-start__banner border border-dark-2 border-radius-lg overflow-hidden">
  <bn-web-ui-card
    class="bn-app-shield-setup-start__banner__card"
    [noBorder]="true"
    [background]="'transparent'"
    [noPadding]="true"
    [noShadow]="true">
    <div class="row g-0">
      <div class="col-6 p-5">
        <div class="text-orange-dark-reverse-gradient text-400-bold">Bunny Shield</div>
        <div class="mt-1 text-700-bold text-bunny-dark">Security simplified</div>
        <p class="mt-1 text-dark-7 text-300-regular">
          Maximize your security with Bunny Shield. It combines cutting-edge web application firewall (WAF) technology, advanced rate limiting, and robust DDoS
          mitigation. Bunny Shield ensures your digital environment stays secure against vulnerabilities and attacks.
        </p>
        <bn-web-ui-button
          class="mt-2 mt-xxl-9 text-400-semi-bold"
          size="xxl"
          (click)="onSetupClick()"
          >Get Started</bn-web-ui-button
        >
      </div>
      <div class="col-6 text-end d-flex align-items-end mt-5">
        <img
          class="bn-app-shield-setup-start__banner__card__image"
          alt="Bunny Holding Shield"
          src="/assets/web-ui/images/bunny-behind-shield.svg" />
      </div>
    </div>
  </bn-web-ui-card>
  <bn-web-ui-card
    [noPadding]="true"
    [noBorder]="true"
    [noShadow]="true"
    [borderRadiuses]="['none', 'none', 'lg', 'lg']">
    <div class="row g-0">
      <div class="col-4 border-right border-dark-2 p-4">
        <p class="text-500-medium text-bunny-dark mb-1">Unmatched security</p>
        <p class="text-200-regular text-dark-6">
          Shield your assets with advanced WAF, real-time detection, and cutting-edge DDoS protection. Bunny Shield delivers unmatched security against evolving
          threats.
        </p>
      </div>
      <div class="col-4 border-right border-dark-2 p-4">
        <p class="text-500-medium text-bunny-dark mb-1">Tailored defenses</p>
        <p class="text-200-regular text-dark-6">
          Customize your defense with adjustable WAF rules, rate limits, and tailored protections. Bunny Shield adapts to your needs for optimal security.
        </p>
      </div>
      <div class="col-4 p-4">
        <p class="text-500-medium text-bunny-dark mb-1">Seamless reliability</p>
        <p class="text-200-regular text-dark-6">
          Never worry about downtime again. Rely on Bunny Shield for secure, reliable performance and a seamless user experience.
        </p>
      </div>
    </div>
  </bn-web-ui-card>
</div>

<div class="row mt-4">
  <div class="col-6">
    <bn-web-ui-card
      heading="What’s included?"
      [isFullHeight]="true">
      <!-- <p>Enhance your web defense</p> -->
      <bn-web-ui-list-with-icon
        class="text-bunny-dark text-200-regular"
        [data]="featuresListItems" />
    </bn-web-ui-card>
  </div>
  <div class="col-6">
    <bn-web-ui-card
      heading="Integrate seamlessly"
      [isFullHeight]="true">
      <p>Our tailored WAF profiles ensure maximum security and minimal false positives, for the best user experience.</p>
      <div class="integrate-seamlessly d-flex flex-wrap align-items-center pt-2">
        <div class="row text-center">
          <div class="col-6 mb-2">
            <img
              class="me-3 mb-3"
              alt="cPanel Logo"
              src="/assets/web-ui/images/shield/cpanel.svg" />
          </div>
          <div class="col-6 mb-2">
            <img
              class="mb-3"
              alt="Plesk Logo"
              src="/assets/web-ui/images/shield/plesk.svg" />
          </div>
          <div class="col-6 mb-2">
            <img
              class="me-3 mb-3"
              alt="Drupal"
              src="/assets/web-ui/images/shield/drupal.svg" />
          </div>
          <div class="col-6 mb-2">
            <img
              class="me-3 mb-3"
              alt="Wordpress Logo"
              src="/assets/web-ui/images/shield/wordpress.svg" />
          </div>
        </div>
      </div>
    </bn-web-ui-card>
  </div>
</div>
<bn-web-ui-card
  class="mt-4"
  overFlow="hidden"
  [isFullHeight]="true">
  <div class="row mt-4">
    <div class="col-12 col-lg-7">
      <img
        width="32px"
        height="32px"
        alt="Global Rate Limiting icon"
        src="/assets/web-ui/images/shield/global-rate-limiting-icon.svg" />
      <p class="text-500-medium text-bunny-dark my-2">Global rate limiting</p>
      <p class="text-200-regular textd-dark-6">
        Secure your website with global rate limiting, using a globally distributed counter to synchronize rate limits across the edge. Control traffic, prevent
        abuse, and mitigate threats while ensuring legitimate access.
      </p>
    </div>
    <div class="col-12 col-lg-5 mt-5 mt-lg-0 text-start text-lg-end">
      <img
        width="441px"
        height="196px"
        [style.max-width]="'100%'"
        alt="Custom Waf Rules"
        src="/assets/web-ui/images/shield/setup-wizard/custom-waf-rules.svg" />
    </div>
  </div>
</bn-web-ui-card>
<bn-web-ui-card
  class="mt-4"
  [isFullHeight]="true"
  overFlow="hidden">
  <div class="row mt-4">
    <div class="col-12 col-lg-7">
      <img
        width="36px"
        height="36px"
        alt="Custom Waf Rules icon"
        src="/assets/web-ui/images/shield/custom-waf-rules-icon.svg" />
      <p class="text-500-medium text-bunny-dark my-2">Build custom WAF rules</p>
      <p class="text-200-regular textd-dark-6">
        Protect your website with custom WAF rules, tailored to block threats, allow trusted traffic, and minimize false positives. Gain precise control for
        advanced, targeted security and peace of mind.
      </p>
    </div>
    <div class="col-12 col-lg-5 mt-5 mt-lg-0 text-start text-lg-end">
      <img
        width="417px"
        height="211px"
        [style.max-width]="'100%'"
        alt="Real Time Visibility"
        src="/assets/web-ui/images/shield/setup-wizard/real-time-visibility.svg" />
    </div>
  </div>
</bn-web-ui-card>
